import React, { useEffect, useRef } from 'react';
// import { createTheme, ThemeProvider } from '@mui/styles';
import { createTheme, ThemeProvider } from '@mui/material/styles';

import Routes from './Routes'
import ColorModeContext from './util/ColorMode'
// import {fpPromise} from './util/BasicInfo'
import { getId, getLic } from './util/ID'
import { grey, red, green } from '@mui/material/colors'

function MobileApp() {
    // const [mode, setMode] = React.useState('light');
    const [mode, setMode] = React.useState(localStorage.getItem("colormode") != null ? localStorage.getItem("colormode") : 'light');

    const checkLic = () => {
        let lic = localStorage.getItem('lic')

        if (lic != null) {
            let a = {
                lic: lic,
                sn: getId()
            }

            fetch("/ocb/v1/stock3/checklic", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(a)
            })
                .then(res => res.json())
                .then(
                    result => {
                        if (result.status === 0) {
                            if (result.hlic != null && (result.hlic.licok === 1 || result.hlic.tp === 3)) {
                                localStorage.setItem('noad', 1);
                                if (window.webkit != undefined) window.webkit.messageHandlers.setAD.postMessage("1");
                            } else {
                                localStorage.setItem('noad', 0);
                                if (window.webkit != undefined) window.webkit.messageHandlers.setAD.postMessage("0");
                            }
                        } else {
                            localStorage.setItem('noad', 0);
                            if (window.webkit != undefined) window.webkit.messageHandlers.setAD.postMessage("0");
                        }
                    },
                    error => {
                        localStorage.setItem('noad', 0);
                        if (window.webkit != undefined) window.webkit.messageHandlers.setAD.postMessage("0");
                    }
                );
        } else localStorage.setItem('noad', 0);
    }

    useEffect(() => {
        checkLic();
    }, []);

    // useEffect(() => {
    //     if(localStorage.getItem("visitorId") == null) {
    //         fpPromise
    //         .then(fp => fp.get())
    //         .then(result => {
    //             localStorage.setItem("visitorId", result.visitorId)
    //         })
    //     }
    // }, []);


    const colorMode = React.useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => {
                    let curMode = prevMode === 'light' ? 'dark' : 'light'
                    localStorage.setItem("colormode", curMode)
                    return curMode
                });
            },
        }),
        [],
    );

    // const theme = React.useMemo(
    //     () =>
    //         createTheme({
    //             palette: {
    //                 neutral: {
    //                     main: '#ebdbd5',
    //                     contrastText: '#fff',
    //                 },
    //                 primary: {
    //                     main: "#FFC75F"
    //                 },
    //                 secondary: {
    //                     main: "#fbfbfb"
    //                 },
    //                 mode: mode
    //             },
    //         }),
    //     [mode],
    // );

    const theme = React.useMemo(
        () =>
            createTheme({
                components: {
                    MuiButton: {
                          styleOverrides: {
                            root: ({ ownerState }) => ({
                              ...(ownerState.variant === 'contained' &&
                                ownerState.color === 'error' && {
                                  backgroundColor: red[400],
                                  color: '#fff',
                                }),...(ownerState.variant === 'contained' &&
                                ownerState.color === 'success' && {
                                  backgroundColor: green[400],
                                  color: '#fff',
                                }),
                            }),
                          },
                    },
                },
                palette: {
                    neutral: {
                        main: '#E9EBE6',
                        contrastText: '#fff',
                    },
                    // primary: {
                    //     main: "#344157"// "#"
                    // },
                    secondary: {
                        main: "#fbfbfb"
                    },

                    mode: mode
                },
            }),
        [mode],
    );

    return (
        <ColorModeContext.Provider value={colorMode}>
            <ThemeProvider theme={theme}>
                <Routes />
            </ThemeProvider>
        </ColorModeContext.Provider>
    );

}

export default MobileApp;
